import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ListTable,
  ModalView,
  TableFilters,
  TableMenuOpt,
} from '../../../uiComponents';
import { getCabains, deleteCabain } from '../../../../appRedux/actions';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { CabainModalBody } from '../CabainModalBody';
import { Button } from 'antd';
import './styles.css';
import {
  filters,
  searchFilters,
  searchInputInitialValues,
} from '../../../../constants/Cabain.const';

export const CabainTable = () => {
  const {
    privileges: { cabain: privileges = [] },
  } = useSelector((state) => state.userAuth);
  const dispatch = useDispatch();
  const [modalData, setModalData] = useState({});
  const { modal } = useCustomModal();

  const onModalClick = (cabain) => {
    modal();
    setModalData(cabain);
  };

  const onDelete = (id) => {
    dispatch(deleteCabain(id));
  };

  const columns = [
    {
      title: 'Nombre',
      sorter: true,
      dataIndex: 'name',
      key: 'name',
      render: (name, cabain) => (
        <Button
          type="link"
          htmlType="button"
          href="#/"
          onClick={() => {
            onModalClick(cabain);
          }}
        >
          {name}
        </Button>
      ),
    },
    {
      title: 'Tipo',
      sorter: true,
      dataIndex: 'type',
      key: 'type',
      render: (type) => <span>{type?.name || '-'}</span>,
      path: 'type.name',
    },
    {
      title: 'Sucursal',
      sorter: true,
      dataIndex: 'branch',
      key: 'branch',
      render: (branch) => <span>{branch?.name || '-'}</span>,
      path: 'branch.name',
    },
    {
      title: 'Usuario',
      sorter: true,
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Opciones',
      key: 'id',
      render: (_, { id }) => (
        <TableMenuOpt
          id={id}
          path="cabinas"
          privileges={privileges}
          action={{
            onDelete: {
              action: onDelete,
              params: [id],
            },
          }}
        />
      ),
    },
  ];
  return (
    <>
      <TableFilters
        privileges={privileges}
        searchFilters={searchFilters}
        filters={filters}
        searchInputInitialValues={searchInputInitialValues}
      />
      <ListTable
        columns={columns}
        getDataFunction={getCabains}
        privileges={privileges}
      />
      <ModalView title="Cabinas">
        <CabainModalBody data={modalData} />
      </ModalView>
    </>
  );
};
